import { useEffect, useState } from "react";
import FlipCard from "./FlipCard";
import { useInView } from "react-intersection-observer";

export default function FlipCountdown({
  start,
  target,
}: {
  start: number;
  target: number;
}) {
  const numberToDigits = (num: number): number[] => {
    const startLength = start.toString().length;
    return num.toString().padStart(startLength, "0").split("").map(Number);
  };

  const [currentNumber, setCurrentNumber] = useState(numberToDigits(start));
  const [nextNumber, setNextNumber] = useState(numberToDigits(start - 1));
  const [skipInView, setSkipInView] = useState(true);

  const { ref, inView } = useInView({
    threshold: 0.8,
    triggerOnce: true,
    rootMargin: "0px 0px -100px",
    skip: skipInView,
  });

  useEffect(() => {
    const initialDelay = setTimeout(() => {
      setSkipInView(false);
    }, 1000);

    return () => clearTimeout(initialDelay);
  }, []);

  useEffect(() => {
    if (start <= target || !inView) return;
    const interval = setInterval(() => {
      setCurrentNumber((prevCurrent) => {
        const currentValue = parseInt(prevCurrent.join(""));

        if (currentValue <= target) {
          return prevCurrent; // Stop counting
        }

        const newValue = currentValue - 1;
        const newCurrentDigits = numberToDigits(newValue);
        const newNextDigits =
          newValue > target
            ? numberToDigits(newValue - 1)
            : numberToDigits(newValue);

        setNextNumber(newNextDigits);
        return newCurrentDigits;
      });
    }, 5000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <div ref={ref} className="flex flex-row gap-1">
      {currentNumber.map((digit, index) => (
        <FlipCard
          key={index}
          currentNumber={digit}
          nextNumber={nextNumber[index]}
        />
      ))}
    </div>
  );
}
